module.exports = __webpack_public_path__ + "img/kubernetes.57557d30.svg";